import { Link } from 'react-router-dom';
import CONFIG from '../../../../../config';
import styles from './AddFamilyMemberButton.module.css';
import iconAddMember from '../../../../assets/img/icons/icon-user-plus.png';


export const AddFamilyMemberButton = () => {
  return (
    <div className={styles.button__container}>
      <Link to={CONFIG.ROUTES.DASHBOARD.FAMILYGROUP.ADDMEMBER} className={styles.button}>
        <img src={iconAddMember} alt="Agregar" className={styles.button__icon} />
        <span className={styles.button__text}>Agregar integrante</span>
      </Link>
    </div>
  )
}
